import { createCamera } from './components/camera.js';
import { createCube } from './components/cube.js';
import { createMesh2 } from './components/mesh2.js';
import { createScene } from './components/scene.js';

import { createRenderer } from './systems/renderer.js';
import { Resizer } from './systems/Resizer.js';

let camera;
let scene;
let renderer;

class World {
  constructor(container) {

    camera = createCamera();
    scene = createScene();
    renderer = createRenderer(container);
    console.log(camera, 'camera', scene, 'scene', renderer, 'renderer');
    // container.append(renderer.domElement); // 添加一个canvas 元素， 我的container已经是 canvas了 这里就注释

    const cube = createCube();
    const cube2Ins = createMesh2();

    cube2Ins.position.set( 3, 0, 0 );

    scene.add(cube);
    scene.add(cube2Ins);

    // eslint-disable-next-line
    const resizer = new Resizer(container, camera, renderer);
  }

  // 2. Render the scene
  render() {
    renderer.render(scene, camera);
  }
}

export { World };